import React, { useState } from 'react';
import axios from 'axios'; 
import './ContactUs.css';
import './responsive.css';

function Tab4Content() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    subject: '',
    query: ''
  });
  const [enquiries, setEnquiries] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
      const { name, value } = event.target;

    setFormData({
      ...formData,
      [name]: name === "email" ? value.toLowerCase() : value // Convert email to lowercase
        });

    if (responseMessage) setResponseMessage('');
  };

    const isValidEmail = (email) => {
      const regex = /^[a-zA-Z0-9._%+-]+@(gmail\.com|hotmail\.com|yahoo\.com|outlook\.com)$/;
      return regex.test(email);
    };

    const isValidContact = (contact) => {
      const regex = /^9[0-9]{7}$|^8[0-9]{7}$/; // Matches 8 digit numbers starting with 8 or 9
      return regex.test(contact);
    };
    
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    if (!isValidEmail(formData.email)) {
      setResponseMessage('Please enter a valid email address (Gmail/Hotmail/Yahoo/Outlook.com)');
      setIsSubmitting(false);
      return;
    }
  
    if (!isValidContact(formData.contact)) {
      setResponseMessage('Please enter a valid Singapore contact number.');
      setIsSubmitting(false);
      return;
    }

    // const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // axios.post('http://localhost:5000/send-email', formData)
    axios.post('https://connoisseuraudio.net/send-email', formData)
      .then(response => {
        setResponseMessage('Email sent successfully');
        setEnquiries([...enquiries, formData]);
        setFormData({ name: '', email: '', contact: '', subject: '', query: '' }); 
      })
      .catch(error => {
        const errorMessage = error.response?.data?.message || 'Failed to send email';
        setResponseMessage(errorMessage);
        console.error('There was an error sending the email!', error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };


  return (
    <div className="Tab4Content">
      <div className="content-wrapper">
        {/* Contact Us Details Section */}
        <div className="contact-details">
          <h2>Contact Us</h2>
          {/* <p><strong>Address:</strong></p>
          <p><strong>Call Us:</strong></p>
          <p><strong>Email Address:</strong></p>
          <p><strong>Opening Hours:</strong></p>

          <p>1 Coleman Street, #03-40</p>
          <p>(+65) 6333 4118</p>
          <p>info@connoisseuraudio.com.sg</p>
          <p>Monday - Saturday: 12-7pm</p>

          <p>The Adelphi</p>
          <p>(+65) 9695 4004</p>
          <p></p>
          <p>Sunday: By Appointment Only</p>

          <p>Singapore 179803</p>
          <p>(+65) 8368 1338</p>
          <p></p> */}
          {/* <p>By Appointment Only</p> */}

           <div className="contact-column">
    <strong>Address:</strong>
    <p>1 Coleman Street, #03-40</p>
    <p>The Adelphi</p>
    <p>Singapore 179803</p>
  </div>

  {/* Column 2: Call Us */}
  <div className="contact-column">
    <strong>Call Us:</strong>
    <p>(+65) 6333 4118</p>
    <p>(+65) 9695 4004</p>
    <p>(+65) 8368 1338</p>
  </div>

  {/* Column 3: Email Address */}
  <div className="contact-column">
    <strong>Email Address:</strong>
    <p>info@connoisseuraudio.com.sg</p>
  </div>

  {/* Column 4: Opening Hours */}
  <div className="contact-column">
    <strong>Opening Hours:</strong>
    <p>Monday - Saturday: 12-7pm</p>
    <p>Sunday: By Appointment Only</p>
  </div>
        </div>
      </div>

      {/* Enquiry Form */}
      <h2>Enquiry Form</h2>
      <div className="table-container">
        <form onSubmit={handleSubmit}>
          <table>
            <tbody>
              <tr>
                <td className="column-1"><label>Name*:</label></td>
                <td className="column-2"><input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                /></td>
              </tr>

              <tr>
                <td className="column-1"><label>Email Address*:</label></td>
                <td className="column-2"><input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                /></td>
              </tr>

              <tr>
                <td className="column-1"><label>Contact Number*:</label></td>
                <td className="column-2"><input
                  type="tel"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                /></td>
              </tr>

              <tr>
                <td className="column-1"><label>Subject:</label></td>
                <td className="column-2"><textarea
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                /></td>
              </tr>

              <tr>
                <td className="column-1"><label>Query:</label></td>
                <td className="column-2"><textarea
                  name="query"
                  value={formData.query}
                  onChange={handleChange}
                  required
                /></td>
              </tr>

              <tr>
                <td colSpan="2">
                  <div className="submit-container">
                  <button type="submit"disabled={isSubmitting}>   {isSubmitting ? 'Submitting...' : 'Submit'}</button> 
                  {responseMessage && <p className="response-message">{responseMessage}</p>}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
        <p className="footer-text">Your email address will not be published. Required fields are marked *</p>

      </div>
    </div>
  );
}

export default Tab4Content;

